import { axiosIns } from "../utils";

const toNumber = (value) => {
  const next = Number(value);
  return Number.isNaN(next) ? value : next;
};

const getFullName = (user) => {
  const firstName = user?.profile?.first_name || "";
  const lastName = user?.profile?.last_name || "";
  const fullName = `${firstName} ${lastName}`.trim();
  return fullName || user?.username || user?.email || `Utilisateur #${user?.id || ""}`;
};

export const normalizeDirectoryUser = (user) => ({
  ...user,
  id: toNumber(user?.id),
  displayName: getFullName(user),
});

export const normalizeMessage = (message) => ({
  ...message,
  id: toNumber(message?.id),
  conversation: toNumber(message?.conversation),
  sender: toNumber(message?.sender),
});

export const normalizeConversation = (conversation, currentUserId) => {
  const user1 = normalizeDirectoryUser(conversation?.user1 || {});
  const user2 = normalizeDirectoryUser(conversation?.user2 || {});
  const me = toNumber(currentUserId);
  const otherUser = user1.id === me ? user2 : user1;
  const messages = Array.isArray(conversation?.messages)
    ? conversation.messages.map(normalizeMessage)
    : [];
  const lastMessage = messages[messages.length - 1] || null;

  return {
    ...conversation,
    id: toNumber(conversation?.id),
    user1,
    user2,
    otherUser,
    messages,
    lastMessage,
  };
};

export const fetchAdminUsers = async () => {
  const response = await axiosIns.get("/users/list/");
  return Array.isArray(response?.data)
    ? response.data.map(normalizeDirectoryUser)
    : [];
};

export const fetchConversations = async (currentUserId) => {
  const response = await axiosIns.get("/conversations/user_conversations/");
  const items = Array.isArray(response?.data) ? response.data : [];
  return items.map((item) => normalizeConversation(item, currentUserId));
};

export const fetchConversationMessages = async (conversationId) => {
  const response = await axiosIns.get(`/messages/${conversationId}/`);
  const items = Array.isArray(response?.data) ? response.data : [];
  return items.map(normalizeMessage);
};

export const createConversation = async (userId, currentUserId) => {
  const response = await axiosIns.post("/conversations/", {
    user2: Number(userId),
  });
  return normalizeConversation(response?.data, currentUserId);
};

export const sendMessage = async ({ conversationId, senderId, content, replyToId }) => {
  const response = await axiosIns.post("/messages/", {
    conversation: Number(conversationId),
    sender: Number(senderId),
    content,
    ...(replyToId ? { replyToId: Number(replyToId) } : {}),
  });
  return normalizeMessage(response?.data);
};
